import type {
  NotificationPreferences,
  UpdateNotificationPreferencesRequest,
} from "@facade/contracts";

import { api } from "@facade/api";

export const notificationPreferencesApi = {
  async get() {
    const { data } = await api.get<NotificationPreferences>(
      "/notification-preferences",
    );
    return data;
  },

  async update(request: UpdateNotificationPreferencesRequest) {
    const { data } = await api.patch<NotificationPreferences>(
      "/notification-preferences",
      request,
    );
    return data;
  },
};
